import React from 'react';
import './Small.styles.css';

export const Small: React.FC = () => {
    return (
      <div className="btn-loader-small"></div>
    );
};
